import angular from "angular";

import {
  ApiListItem,
  Employments,
  ODataQueryOptions,
  ODataResult,

} from "@salaxy/core";



/**
 * Controller handles Employer selection
 */
export class EmployerSelectController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = ["Employments"];

  /** Employing relations for the current account */
  public employingRelations: ApiListItem[] = [];


  /** Items once loaded from the server. This is an empty array when the loading starts. */
  public items: any[];

  /** Selected search items */
  public selectedItems: any[];

  /** True if any employer is selected */
  public showFullEmployerList: boolean;

  /**
   * Creates a new EmployerSelectController
   * @ignore
   */
  constructor(
    private employmentsApi: Employments
  ) {
  }

  /**
   * Implement IController
   */
  public $onInit() {
    this.loadEmployingRelations();
    this.selectedItems = this.selectedItems || [];
    this.items = this.items || [];
  }


  /**
   * Loads employing relations of the existing employers for the current account.
   * @param options OData query options.
   */
  public loadEmployingRelations(options: ODataQueryOptions = null): Promise<ApiListItem[]> {

    return this.employmentsApi.getODataForEmployingRelations(options).then((result: ODataResult<ApiListItem>) => {

      // filter out duplicates, default sort is updatedAt desc
      const distinctItems: ApiListItem[] = [];
      result.items.forEach((x) => {
        if (distinctItems.findIndex((d) => d.ownerId === x.ownerId) === -1) {
          distinctItems.push(x);
        }
      });
      this.employingRelations = distinctItems;
      if (this.employingRelations.length == 1) {
        this.setEmployerSelected(this.employingRelations[0], true);
      }

      return this.employingRelations;
    });
  }

  /**
   * Function that is called when user selects an employer in the list.
   * Function has the following locals: value: true/false, item: the last selected/unselected item.
   * @example <salaxy-employer-select on-employer-select="$ctrl.onEmployerSelect($ctrl.current, value, item)"></salaxy-employer-select>
   */
  public onEmployerSelect: (params: {

    /** In multi-select mode, the value may be true (selected) or false (unselected). */
    value: true | false,
    /** Item that was last selected / deselected. */
    item: any,

    /** All items that are currently selected. */
    allItems: any[],

  }) => void;


  /**
   * Sets an item as selected.
   * @param item Item to set as selected
   * @param value Selected true / false or "toggle" to toggle to other value.
   */
  public setEmployerSelected(item: any, value: true | false | "toggle" = true) {
    // TODO: This now only supports items with id. Add other identifiers if necessary.
    const ix = this.selectedItems.findIndex((x) => x.ownerId === item.ownerId);
    const exists = ix >= 0;
    if (exists) {

      this.selectedItems.splice(ix, 1);
    }
    switch (value) {
      case true:
        this.selectedItems.push(item);
        break;
      case false:
        // Already done
        break;
      case "toggle":
        if (!exists) {
          this.selectedItems.push(item);
        }
        break;
    }
    this.onEmployerSelect({
      value: value === "toggle" ? !exists : value,
      item,
      /** All items that are currently selected. */
      allItems: this.selectedItems,
    });
  }


  /**
   * Returns true if the item is selected.
   * @param item Item to check for selected value.
   */
  public isEmployerSelected(item: any) {
    return this.selectedItems.findIndex((x) => x.ownerId === item.ownerId) >= 0;
  }


  /** Unselect all */
  public unselectAll() {

    if (this.selectedItems) {
      this.selectedItems.splice(0, this.selectedItems.length);
      this.showFullEmployerList = true;
    }
  }
}
